const openPopup = (url: string, width = 600, height = 800, name: string = url) => {
  window.open(url, name, `width=${width},height=${height}`);
};

export { openPopup };
